/**
 * Hook to abstract handling of booleans.
 *
 * @example
 *
 * const {
 *  value,
 *  setValue,
 *  setTrue,
 *  setFalse,
 *  toggle
 * } = useBoolean(false);
 *
 * return (
 *   <>
 *     <p>
 *       Value is <code>{value.toString()}</code>
 *     </p>
 *     <button onClick={setTrue}>set true</button>
 *     <button onClick={setFalse}>set false</button>
 *     <button onClick={toggle}>toggle</button>
 *     <button onClick={customToggle}>custom toggle</button>
 *   </>
 * );
 *
 */
import { useCallback, useState } from "react";

function useBoolean(defaultValue) {
  const [value, setValue] = useState(Boolean(defaultValue));
  const setTrue = useCallback(() => setValue(true), []);
  const setFalse = useCallback(() => setValue(false), []);
  const toggle = useCallback(() => setValue(x => !x), []);
  return {
    value,
    setValue,
    setTrue,
    setFalse,
    toggle
  };
}

export default useBoolean;